import { useState } from "react";

import showHorizontal from "../../assets/images/73-collapse.svg";
import showVertical from "../../assets/images/73-expand.svg";
import handler from "../../assets/images/73-handler.svg";
import iconNxt from "../../assets/images/73-nxt.svg";
import iconPrv from "../../assets/images/73-prv.svg";
import iconLayers from "../../assets/images/73-steps.svg";
import img3 from "../../assets/images/desktop-lnx.png";
import img2 from "../../assets/images/desktop-mac.jpg";
import img4 from "../../assets/images/desktop-win.png";
import img1 from "../../assets/images/step-thumb-1.png";

import StepListSingleItem from "./step-list-single-item";

const StepList = () => {
  const [firstItem, setFirstItem] = useState(0);
  const [horizontalDisplayMode, setHorizontalDisplayMode] = useState(true);

  const data = [
    { id: 1, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 2, src: img2, effectType: "keybord", isRemove: false, selected: false },
    { id: 3, src: img3, effectType: "mouse", isRemove: true, selected: false },
    { id: 4, src: img4, effectType: "mouse", isRemove: false, selected: false },
    { id: 5, src: img1, effectType: "keybord", isRemove: false, selected: false },
    { id: 6, src: img2, effectType: "mouse", isRemove: false, selected: false },
    { id: 7, src: img3, effectType: "keybord", isRemove: false, selected: false },
    { id: 8, src: img4, effectType: "mouse", isRemove: false, selected: false },
    { id: 9, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 10, src: img2, effectType: "keybord", isRemove: false, selected: false },
    { id: 11, src: img3, effectType: "mouse", isRemove: false, selected: false },
    { id: 12, src: img4, effectType: "mouse", isRemove: false, selected: false },
    { id: 13, src: img2, effectType: "mouse", isRemove: false, selected: false },
    { id: 14, src: img3, effectType: "mouse", isRemove: false, selected: false },
    { id: 15, src: img3, effectType: "mouse", isRemove: false, selected: false },
    { id: 16, src: img2, effectType: "mouse", isRemove: false, selected: false },
    { id: 17, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 18, src: img4, effectType: "mouse", isRemove: false, selected: false },
    { id: 19, src: img4, effectType: "keybord", isRemove: false, selected: false },
    { id: 20, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 21, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 22, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 23, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 24, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 25, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 26, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 27, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 28, src: img1, effectType: "keybord", isRemove: false, selected: false },
    { id: 29, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 30, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 31, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 32, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 33, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 34, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 35, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 36, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 37, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 38, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 39, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 40, src: img1, effectType: "mouse", isRemove: false, selected: false },
    { id: 41, src: img1, effectType: "mouse", isRemove: false, selected: false },
  ];

  const cpData = [...data];
  const row = cpData.splice(firstItem, 10);
  const distance = Math.floor(data.length / 10) * 80;
  return (
    <div className="step-list-section" style={{ bottom: !horizontalDisplayMode ? `${distance}` : null }}>
      <div className="space-between align-items-center">
        <div className="flex">
          <div className="step-list-count">
            <div className="align-items-center">
              <img alt="" src={iconLayers} width={16} className="m-r-5" />
              <span className="font-12">
                {" "}
                {firstItem + 1} - {firstItem + 1 + row.length - 1} of {data.length}{" "}
              </span>
            </div>
            <div className="flex pointer">
              <img
                alt=""
                src={horizontalDisplayMode ? showHorizontal : showVertical}
                width={32}
                onClick={() => data.length > 10 && setHorizontalDisplayMode(!horizontalDisplayMode)}
                className={`btn ${horizontalDisplayMode ? "btn-collapse2" : "btn-extend2"} ${data.length < 11 ? "disable" : null} `}
              />
            </div>
          </div>
        </div>
        {horizontalDisplayMode && data.length > 10 && row.length > 1 && (
          <div className="flex">
            <div className="flex" onClick={() => firstItem > 0 && setFirstItem(firstItem - 1)}>
              <img alt="" src={iconPrv} className={`btn btn-32 btn-prv m-r-5 ${firstItem > 0 ? null : "disable"} `} />
            </div>
            <div className="flex" onClick={() => firstItem + row.length < data.length && setFirstItem(firstItem + 1)}>
              <img alt="" src={iconNxt} width={32} className={`btn btn-nxt ${firstItem + row.length < data.length ? null : "disable"}`} />
            </div>
          </div>
        )}
      </div>
      <div className={`step-list-contaner ${data.length > 9 ? "full-width" : null} ${!horizontalDisplayMode ? "step-list-max-height" : null}`}>
        {horizontalDisplayMode && (
          <div className="step-list-row">
            {row.map((i) => (
              <StepListSingleItem key={i.id} id={i.id} isRemove={i.isRemove} src={i.src} effectType={i.effectType} activeItem={i.selected} />
            ))}
          </div>
        )}

        {!horizontalDisplayMode && (
          <div className="step-list-row vertical">
            {data.map((i) => (
              <StepListSingleItem key={i.id} id={i.id} isRemove={i.isRemove} src={i.src} effectType={i.effectType} activeItem={i.selected} />
            ))}
          </div>
        )}
        <div className="step-list-handler" style={{ left: "470px" }}>
          <img alt="" src={handler} height={80} />
        </div>
      </div>
    </div>
  );
};

export default StepList;
